module.exports = __webpack_public_path__ + "img/slavia-praha-logo-icon.58efa28e.png";